import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

import Vue from 'vue'
import Router from 'vue-router'
import store from "../vuex/store.js";
import Cookies from "js-cookie";


// Admin pages
import Overview from 'src/pages/Overview.vue'




//INSPECTIONS
import Inspections from 'src/pages/Inspections/List.vue'
import InspectionsNew from 'src/pages/Inspections/New.vue'
import InspectionsReview from 'src/pages/Inspections/Review.vue'
import InspectionsEdit from 'src/pages/Inspections/Edit.vue'
//Profile
import Profile from 'src/pages/Profile/Edit.vue'

//AUTH
import Login from 'src/pages/Auth/Login.vue'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/login'
  },
  {
    path: '/login',
    component: Login,
    children: [
      {
        path: '/login',
        name: 'login',
        component: Login
      },


    ]
  },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
    
      {
        path: 'profile',
        name: 'Profile',
        component: Profile
      },
    
     
     
     
     
    
     
      //Inspections
      {
        path: 'inspections',
        name: 'Inspections',
        component: Inspections
      },
      {
        path: 'inspections/review/:id',
        name: 'InspectionsReview',
        component: InspectionsReview
      },
      {
        path: 'inspections/new',
        name: 'InspectionsNew',
        component: InspectionsNew
      },
      {
        path: 'inspections/edit/:id',
        name: 'InspectionsEdit',
        component: InspectionsEdit
      },
      // Profile
      
     
     
    
     
     
   
     
     




    ]
  },
  { path: '*', component: NotFound }
]
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  console.log('accediendo')
  const accessToken = Cookies.get("access_token");

  if (accessToken) {
    if (to.matched.some(record => record.meta.requiresAuth) && !store.state.status && !accessToken) {
      alert('Please, sign in to continue')
      next("/login");
    } else if (store.state.status && accessToken) {
      console.log('logged')
      next("/admin/overview")
    } else {
      console.log('Next')
      next()
    }
  } else {
    console.log('TOKEN NOT FOUND');
    console.log(to.name)
    console.log(from.name)
    if (to.name != 'login') {
      next("/login");
    } else {
      next();
    }

  }

})
/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default router
